import { render } from "./NewArea.vue?vue&type=template&id=1f1926c4"
import script from "./NewArea.vue?vue&type=script&lang=js"
export * from "./NewArea.vue?vue&type=script&lang=js"

import "./NewArea.vue?vue&type=style&index=0&id=1f1926c4&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__